export default __webpack_public_path__ + "static/media/iconSecondStep.39e82ef3.svg";